import ColorVariant from './ColorVariant.js';

class Colors {
  constructor(options = {}, base) {
    this.light = new ColorVariant(options.light, base === null || base === void 0 ? void 0 : base.light);
    this.dark = new ColorVariant(options.dark, base === null || base === void 0 ? void 0 : base.dark);
    this.muted = new ColorVariant(options.muted, base === null || base === void 0 ? void 0 : base.muted);
  }
  toVuetifyOptions() {
    const light = this.light.toVuetifyOptions();
    const dark = this.dark.toVuetifyOptions();
    const muted = this.muted.toVuetifyOptions();
    return {
      light,
      dark,
      muted
    };
  }
  install() {
    this.installLocal('wtg-colors');
  }
  installLocal(className) {
    let classes = '';
    classes += this.updateValidationStateTextFieldColors(className);
    if (classes) {
      this.element = document.createElement('style');
      this.element.setAttribute('id', 'local-colors');
      document.body.appendChild(this.element);
      this.element.appendChild(document.createTextNode(classes));
    }
  }
  uninstall() {
    if (this.element) {
      document.body.removeChild(this.element);
      this.element = undefined;
    }
  }
  updateValidationStateTextFieldColors(className) {
    let result = '';
    result += `.${className} .theme--light.wtg-field-info-text.v-text-field--outlined:not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {border: 2px solid; border-color: ${this.light.info}; }`;
    result += `.${className} .theme--dark.wtg-field-info-text.v-text-field--outlined:not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {border: 2px solid; border-color: ${this.dark.info}; }`;
    result += `.${className} .theme--light.wtg-field-info-text.v-text-field > .v-input__control > .v-input__slot { caret-color: ${this.light.info};  color: ${this.light.info} !important; }`;
    result += `.${className} .theme--dark.wtg-field-info-text.v-text-field > .v-input__control > .v-input__slot { caret-color: ${this.dark.info};  color: ${this.dark.info} !important; }`;
    result += `.${className} .theme--light.wtg-field-info-text.v-text-field > .v-input__control > .v-input__slot::before { border-color: ${this.light.info} !important; }`;
    result += `.${className} .theme--dark.wtg-field-info-text.v-text-field > .v-input__control > .v-input__slot::before { border-color: ${this.dark.info} !important; }`;
    result += `.${className} .theme--light.wtg-field-info-text .v-label.theme--light { color: ${this.light.info}}`;
    result += `.${className} .theme--dark.wtg-field-info-text .v-label.theme--dark { color: ${this.dark.info}}`;
    result += `.${className} .theme--light.wtg-field-info-text .v-messages.theme--light .v-messages__message { color: ${this.light.info}}`;
    result += `.${className} .theme--dark.wtg-field-info-text .v-messages.theme--dark .v-messages__message { color: ${this.dark.info}}`;
    result += `.${className} .theme--light.wtg-field-info-text div[class^="v-input--"] { color: ${this.light.info}}`;
    result += `.${className} .theme--dark.wtg-field-info-text div[class^="v-input--"] { color: ${this.dark.info}}`;
    result += `.${className} .theme--light.wtg-field-warning-text.v-text-field--outlined:not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {border: 2px solid; border-color: ${this.light.warning}; }`;
    result += `.${className} .theme--dark.wtg-field-warning-text.v-text-field--outlined:not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {border: 2px solid; border-color: ${this.dark.warning}; }`;
    result += `.${className} .theme--light.wtg-field-warning-text.v-text-field > .v-input__control > .v-input__slot { caret-color: ${this.light.warning};  color: ${this.light.warning} !important; }`;
    result += `.${className} .theme--dark.wtg-field-warning-text.v-text-field > .v-input__control > .v-input__slot { caret-color: ${this.dark.warning};  color: ${this.dark.warning} !important; }`;
    result += `.${className} .theme--light.wtg-field-warning-text.v-text-field > .v-input__control > .v-input__slot::before { border-color: ${this.light.warning} !important; }`;
    result += `.${className} .theme--dark.wtg-field-warning-text.v-text-field > .v-input__control > .v-input__slot::before { border-color: ${this.dark.warning} !important; }`;
    result += `.${className} .theme--light.wtg-field-warning-text .v-label.theme--light { color: ${this.light.warning}}`;
    result += `.${className} .theme--dark.wtg-field-warning-text .v-label.theme--dark { color: ${this.dark.warning}}`;
    result += `.${className} .theme--light.wtg-field-warning-text .v-messages.theme--light .v-messages__message { color: ${this.light.warning}}`;
    result += `.${className} .theme--dark.wtg-field-warning-text .v-messages.theme--dark .v-messages__message { color: ${this.dark.warning}}`;
    result += `.${className} .theme--light.wtg-field-warning-text div[class^="v-input--"] { color: ${this.light.warning}}`;
    result += `.${className} .theme--dark.wtg-field-warning-text div[class^="v-input--"] { color: ${this.dark.warning}}`;
    return result;
  }
}

export { Colors as default };
